export const getPenStudyAnalysesData = state => state.penStudyAnalyses.all;
export const getPenStudyAnalysisData = state => state.penStudyAnalyses.penStudyAnalysis;
export const penStudyAnalysesIsFetching = state => state.penStudyAnalyses.loading.all;
export const penStudyAnalysisIsFetching = state => state.penStudyAnalyses.loading.penStudyAnalysis;